// OnePlaceHQ Gym - Membership management with WhatsApp receipts
// Version: 1.0.0
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { toastPlugin } from '@shared/plugins/toastPlugin.js'
import App from './App.vue'
import router from './router'

// Import shared styles (Intercom design system)
import '@shared/styles/intercom-tokens.css'
import '@shared/styles/intercom-base.css'
import '@shared/styles/intercom-toast.css'

// Import locale messages
import en_IN from './locales/en_IN.json'

// Detect browser language and get saved locale
const detectLocale = () => {
  const saved = localStorage.getItem('gym_locale')
  if (saved) return saved

  // Detect browser language (Tamil = ta, ta-IN, etc.)
  const browserLang = navigator.language || navigator.userLanguage || ''
  if (browserLang.startsWith('ta')) {
    localStorage.setItem('gym_locale', 'ta_IN')
    return 'ta_IN'
  }
  return 'en_IN'
}
const savedLocale = detectLocale()

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en_IN',
  messages: {
    en_IN,
  },
})

// Create Vue app
const app = createApp(App)

// Install plugins
app.use(router)
app.use(i18n)
app.use(toastPlugin)

// Mount app
app.mount('#app')
